// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.allig-show-per-page[data-v-3e5e990d]{\r\n  font-family: 'Noto Sans JP', sans-serif !important;\n}\n.text-caption[data-v-3e5e990d]{\r\n  color: #72727E;\n}\r\n", ""]);
// Exports
module.exports = exports;
